import '@fontsource-variable/inter'
import './styles/app.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './lib/api/client'
import { persistQueryCache, restoreQueryCache } from './lib/api/persist'
import { installChunkRecovery } from './lib/chunk-recovery'
import { createAppRouter, createQueryClient } from './router'

installChunkRecovery()

const queryClient = createQueryClient()
// Cold open: render what this browser last loaded, then revalidate (scope §5.0 States).
restoreQueryCache(queryClient)
persistQueryCache(queryClient)
const router = createAppRouter(queryClient)

const root = document.getElementById('root')
if (!root) throw new Error('#root missing')
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
